/** Shared chrome: actions, field labels, placeholders. */
const dictionary = {
  "en": {
    "actions": {
      "save": "Save changes",
      "saveShort": "Save",
      "cancel": "Cancel",
      "add": "Add",
      "next": "Next",
      "previous": "Previous",
      "back": "Back",
      "skip": "Skip",
      "finish": "Finish",
      "invite": "Invite",
      "confirm": "Confirm",
      "delete": "Delete",
      "copy": "Copy",
      "submit": "Submit",
      "verify": "Verify",
      "reset": "Reset",
      "close": "Close",
      "search": "Search",
      "showMore": "Show more",
      "showLess": "Show less",
      "watchDemo": "Watch demo video",
      "edit": "Edit"
    },
    "fields": {
      "email": "Email",
      "emailAddress": "Email address",
      "password": "Password",
      "repeatPassword": "Repeat password",
      "firstName": "First name",
      "lastName": "Last name",
      "fullName": "Full name",
      "companyName": "Company name",
      "phoneNumber": "Phone number",
      "employeeCount": "Employee number",
      "workEmail": "Work email",
      "businessType": "Business type"
    },
    "placeholders": {
      "startTyping": "Start typing...",
      "selectTeamSize": "Select team size",
      "search": "Search...",
      "enterEmail": "Enter Email...",
      "enterCurrentPassword": "Enter Current Password...",
      "enterNewPassword": "Enter New Password...",
      "confirmPassword": "Confirm Password...",
      "enterCode": "Enter the code here...",
      "searchTeamMemberEmail": "Search team member by email",
      "selectBusinessType": "Select business type",
      "selectCompanySize": "Select number of employees",
      "select": "Select",
      "selectIndustry": "Select industry"
    },
    "labels": {
      "from": "From",
      "to": "To",
      "name": "Name",
      "role": "Role",
      "actions": "Actions",
      "groups": "Groups",
      "language": "Language",
      "off": "OFF",
      "on": "ON",
      "optional": "Optional",
      "search": "search",
      "loading": "Loading...",
      "success": "Success"
    },
    "scale": {
      "low": "Low",
      "average": "Average",
      "high": "High",
      "howToLead": "How to lead",
      "howToDevelop": "How to develop",
      "howToManage": "How to manage",
      "watchOut": "WATCH OUT"
    },
    "verifiedByAon": "Verified by AON online assessments",
    "invalidField": "Invalid field",
    "comingSoonAlt": "page is under construction and coming soon",
    "tableFilter": {
      "startsWith": "Starts with",
      "contains": "Contains",
      "notContains": "Not contains",
      "endsWith": "Ends with",
      "equals": "Equals",
      "notEquals": "Not equals",
      "noFilter": "No Filter",
      "filter": "Filter",
      "lessThan": "Less than",
      "lessThanOrEqual": "Less than or equal to",
      "greaterThan": "Greater than",
      "greaterThanOrEqual": "Greater than or equal to",
      "dateIs": "Date is",
      "dateIsNot": "Date is not",
      "dateBefore": "Date is before",
      "dateAfter": "Date is after",
      "custom": "Custom",
      "clear": "Clear",
      "close": "Close",
      "apply": "Apply",
      "matchAll": "Match All",
      "matchAny": "Match Any",
      "addRule": "Add Rule",
      "removeRule": "Remove Rule",
      "noResults": "No results found",
      "noOptions": "No available options"
    },
    "employeeSizeLabels": {
      "1-49": "1–49 employees",
      "50-249": "50–249 employees",
      "250-999": "250–999 employees",
      "1000-4999": "1,000–4,999 employees",
      "5000+": "5,000+ employees"
    },
    "orSignInWith": "Or sign in with"
  },
  "de": {
    "actions": {
      "save": "Änderungen speichern",
      "saveShort": "Speichern",
      "cancel": "Abbrechen",
      "add": "Hinzufügen",
      "next": "Weiter",
      "previous": "Zurück",
      "back": "Zurück",
      "skip": "Überspringen",
      "finish": "Abschließen",
      "invite": "Einladen",
      "confirm": "Bestätigen",
      "delete": "Löschen",
      "copy": "Kopieren",
      "submit": "Absenden",
      "verify": "Prüfen",
      "reset": "Zurücksetzen",
      "close": "Schließen",
      "search": "Suchen",
      "showMore": "Mehr anzeigen",
      "showLess": "Weniger anzeigen",
      "watchDemo": "Demo-Video ansehen",
      "edit": "Bearbeiten"
    },
    "fields": {
      "email": "E-Mail",
      "emailAddress": "E-Mail-Adresse",
      "password": "Passwort",
      "repeatPassword": "Passwort wiederholen",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "fullName": "Vollständiger Name",
      "companyName": "Unternehmensname",
      "phoneNumber": "Telefonnummer",
      "employeeCount": "Anzahl der Mitarbeitenden",
      "workEmail": "Geschäftliche E-Mail",
      "businessType": "Branche"
    },
    "placeholders": {
      "startTyping": "Tippen Sie hier...",
      "selectTeamSize": "Teamgröße wählen",
      "search": "Suchen...",
      "enterEmail": "E-Mail eingeben...",
      "enterCurrentPassword": "Aktuelles Passwort eingeben...",
      "enterNewPassword": "Neues Passwort eingeben...",
      "confirmPassword": "Passwort bestätigen...",
      "enterCode": "Code hier eingeben...",
      "searchTeamMemberEmail": "Teammitglied nach E-Mail suchen",
      "selectBusinessType": "Branche wählen",
      "selectCompanySize": "Anzahl der Mitarbeitenden wählen",
      "select": "Auswählen",
      "selectIndustry": "Branche wählen"
    },
    "labels": {
      "from": "Von",
      "to": "Bis",
      "name": "Name",
      "role": "Rolle",
      "actions": "Aktionen",
      "groups": "Gruppen",
      "language": "Sprache",
      "off": "AUS",
      "on": "AN",
      "optional": "Optional",
      "search": "suchen",
      "loading": "Wird geladen...",
      "success": "Erfolg"
    },
    "scale": {
      "low": "Niedrig",
      "average": "Durchschnitt",
      "high": "Hoch",
      "howToLead": "Führen",
      "howToDevelop": "Entwickeln",
      "howToManage": "Führen",
      "watchOut": "ACHTUNG"
    },
    "verifiedByAon": "Verifiziert durch AON-Online-Assessments",
    "invalidField": "Ungültiges Feld",
    "comingSoonAlt": "Seite befindet sich im Aufbau und kommt bald",
    "tableFilter": {
      "startsWith": "Beginnt mit",
      "contains": "Enthält",
      "notContains": "Enthält nicht",
      "endsWith": "Endet mit",
      "equals": "Gleich",
      "notEquals": "Nicht gleich",
      "noFilter": "Kein Filter",
      "filter": "Filter",
      "lessThan": "Kleiner als",
      "lessThanOrEqual": "Kleiner oder gleich",
      "greaterThan": "Größer als",
      "greaterThanOrEqual": "Größer oder gleich",
      "dateIs": "Datum ist",
      "dateIsNot": "Datum ist nicht",
      "dateBefore": "Datum ist vor",
      "dateAfter": "Datum ist nach",
      "custom": "Benutzerdefiniert",
      "clear": "Löschen",
      "close": "Schließen",
      "apply": "Anwenden",
      "matchAll": "Alle erfüllen",
      "matchAny": "Eine erfüllen",
      "addRule": "Regel hinzufügen",
      "removeRule": "Regel entfernen",
      "noResults": "Keine Ergebnisse gefunden",
      "noOptions": "Keine Optionen verfügbar"
    },
    "employeeSizeLabels": {
      "1-49": "1–49 Mitarbeitende",
      "50-249": "50–249 Mitarbeitende",
      "250-999": "250–999 Mitarbeitende",
      "1000-4999": "1.000–4.999 Mitarbeitende",
      "5000+": "5.000+ Mitarbeitende"
    },
    "orSignInWith": "Oder anmelden mit"
  },
  "fi": {
    "actions": {
      "save": "Tallenna muutokset",
      "saveShort": "Tallenna",
      "cancel": "Peruuta",
      "add": "Lisää",
      "next": "Seuraava",
      "previous": "Edellinen",
      "back": "Takaisin",
      "skip": "Ohita",
      "finish": "Valmis",
      "invite": "Kutsu",
      "confirm": "Vahvista",
      "delete": "Poista",
      "copy": "Kopioi",
      "submit": "Lähetä",
      "verify": "Vahvista",
      "reset": "Nollaa",
      "close": "Sulje",
      "search": "Hae",
      "showMore": "Näytä lisää",
      "showLess": "Näytä vähemmän",
      "watchDemo": "Katso esittelyvideo",
      "edit": "Muokkaa"
    },
    "fields": {
      "email": "Sähköposti",
      "emailAddress": "Sähköpostiosoite",
      "password": "Salasana",
      "repeatPassword": "Toista salasana",
      "firstName": "Etunimi",
      "lastName": "Sukunimi",
      "fullName": "Koko nimi",
      "companyName": "Yrityksen nimi",
      "phoneNumber": "Puhelinnumero",
      "employeeCount": "Henkilöstömäärä",
      "workEmail": "Työsähköposti",
      "businessType": "Liiketoimintatyyppi"
    },
    "placeholders": {
      "startTyping": "Ala kirjoittaa...",
      "selectTeamSize": "Valitse tiimin koko",
      "search": "Hae...",
      "enterEmail": "Anna sähköpostiosoite...",
      "enterCurrentPassword": "Anna nykyinen salasana...",
      "enterNewPassword": "Anna uusi salasana...",
      "confirmPassword": "Vahvista salasana",
      "enterCode": "Syötä koodi tähän...",
      "searchTeamMemberEmail": "Hae tiimin jäsentä sähköpostiosoitteella",
      "selectBusinessType": "Valitse liiketoimintatyyppi",
      "selectCompanySize": "Valitse työntekijöiden määrä",
      "select": "Valitse",
      "selectIndustry": "Valitse toimiala"
    },
    "labels": {
      "from": "Alkaen",
      "to": "Päättyen",
      "name": "Nimi",
      "role": "Rooli",
      "actions": "Toiminnot",
      "groups": "Ryhmät",
      "language": "Kieli",
      "off": "POIS",
      "on": "PÄÄLLÄ",
      "optional": "Valinnainen",
      "search": "hae",
      "loading": "Ladataan...",
      "success": "Onnistui"
    },
    "scale": {
      "low": "Matala",
      "average": "Keskiarvo",
      "high": "Korkea",
      "howToLead": "Johtamisvinkit",
      "howToDevelop": "Kehittymisvinkit",
      "howToManage": "Johtamisvinkit",
      "watchOut": "HUOMIOI"
    },
    "verifiedByAon": "Vahvistettu AON:n verkkoarvioinneilla",
    "invalidField": "Virheellinen kenttä",
    "comingSoonAlt": "sivu on rakenteilla ja tulossa pian",
    "tableFilter": {
      "startsWith": "Alkaa",
      "contains": "Sisältää",
      "notContains": "Ei sisällä",
      "endsWith": "Päättyy",
      "equals": "On yhtä kuin",
      "notEquals": "Ei ole yhtä kuin",
      "noFilter": "Ei suodatinta",
      "filter": "Suodatin",
      "lessThan": "Pienempi kuin",
      "lessThanOrEqual": "Pienempi tai yhtä suuri kuin",
      "greaterThan": "Suurempi kuin",
      "greaterThanOrEqual": "Suurempi tai yhtä suuri kuin",
      "dateIs": "Päivämäärä on",
      "dateIsNot": "Päivämäärä ei ole",
      "dateBefore": "Päivämäärä on aiempi kuin",
      "dateAfter": "Päivämäärä on myöhempi kuin",
      "custom": "Mukautettu",
      "clear": "Tyhjennä",
      "close": "Sulje",
      "apply": "Käytä",
      "matchAll": "Kaikki ehdot",
      "matchAny": "Mikä tahansa ehto",
      "addRule": "Lisää sääntö",
      "removeRule": "Poista sääntö",
      "noResults": "Tuloksia ei löytynyt",
      "noOptions": "Ei vaihtoehtoja saatavilla"
    },
    "employeeSizeLabels": {
      "1-49": "1–49 työntekijää",
      "50-249": "50–249 työntekijää",
      "250-999": "250–999 työntekijää",
      "1000-4999": "1 000–4 999 työntekijää",
      "5000+": "5 000+ työntekijää"
    },
    "orSignInWith": "Tai kirjaudu sisään käyttäen"
  }
};

export default dictionary;
